import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
// import PartnerSlider from "../../default-components/PartnerSlider";
// import OfferBanners from "../../default-components/OfferBanners";
// import AddBookingIcon from "../../../../default-components/AddBookingIcon";
import "./PGProducts.css";
// import Products from "../../default-components/products-two";
import Productstwo from "../../default-components/productsTwo/Productstwo";
import CorporateTwoClients from "../../templates/corporate/corporateTwo/corporateTwoComponents/CorporateTwoClients/CorporateTwoClients";

const PGProducts = () => {
  const location = useLocation();
  // Scroll to the top of the page whenever the location changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
      {/* Offer Banner Section */}
      {/* <OfferBanners
        category="offers"
        pageName="home"
        section="offers"
        // addMoreImagesButton={false}
        addMoreVideosButton={false}
        addMoreTextContentButton={false}
      /> */}
      <Productstwo />

      <div className="medium_margin_div"></div>

      {/* Our Partner section */}
      <CorporateTwoClients
        category="partners"
        pageName="home"
        section="partners"
        addMoreVideosButton={false}
        addMoreTextContentButton={false}
      />
    </div>
  );
};

export default PGProducts;
